import React from "react";

export const Conditioned = (props) => props.condition ? props.verified || null : props.notVerified || null;

